module.exports = __webpack_public_path__ + "img/Obs.b7a0df77.svg";